<template>
  <hr-form-dialog
    ref="dialog"
    size="md"
    :title="$t('sessions.noteTemplate.editSessionNoteField.previewTitle')"
    @hide="onDialogHide"
  >
    <div class="row q-col-gutter-md">
      <div class="col-12">
        <hr-info-banner :message="$t('sessions.noteTemplate.editSessionNoteField.previewHint')" />
      </div>
      <div
        class="col-12"
        @keydown.enter="preventImplicitSubmit"
      >
        <session-note-field-form
          :session-note-field="editSessionNoteField"
          :session="null"
          @input="onSetSessionNoteFieldValue"
          @change-date="onSetSessionNoteFieldValue"
          @select-option="onSetSessionNoteFieldValue"
          @select-single-option="onSetSessionNoteFieldValue"
        />
      </div>
    </div>
    <template #actions>
      <hr-dismiss-btn
        :label="$t('common.buttonClose')"
        @click="hide"
      />
    </template>
  </hr-form-dialog>
</template>
<script>
import SessionNoteFieldForm from 'components/Sessions/SessionNoteTemplates/SessionNoteFieldForm';
import { set } from 'lodash';
import {
  HrDismissBtn,
  HrFormDialog,
  HrInfoBanner,
} from 'src/design-system';

export default {
  name: 'PreviewSessionNoteFieldForm',

  components: {
    HrDismissBtn,
    HrFormDialog,
    HrInfoBanner,
    SessionNoteFieldForm,
  },

  props: {
    sessionNoteField: {
      type: Object,
      required: true,
    },
  },

  emits: ['hide'],

  data() {
    return {
      editSessionNoteField: { },
    };
  },

  watch: {
    sessionNoteField: {
      deep: false,
      immediate: true,
      handler(newSessionNoteField) {
        this.editSessionNoteField = {
          ...newSessionNoteField,
          value: undefined,
        };
      },
    },
  },
  methods: {

    // following method is REQUIRED
    // (don't change its name --> "show")
    show() {
      this.$refs.dialog.show();
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    },

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    }, // onDialogHide()

    onSetSessionNoteFieldValue({ selectedDate }) {
      set(this.editSessionNoteField, 'value', selectedDate);
    },

    onChangeDate(value) {
      this.editSessionNoteField.value = value;
    },

    // The preview has nothing to submit, but Enter in a single-line input would submit the
    // dialog's form and show validation errors on the previewed field.
    preventImplicitSubmit(event) {
      if (event.target.tagName === 'INPUT') {
        event.preventDefault();
      }
    }, // preventImplicitSubmit()

  },
};
</script>
